import React, {Component} from 'react';
import Button from 'material-ui/Button';
import Dialog, {DialogActions, DialogContent, DialogContentText, DialogTitle} from 'material-ui/Dialog';
import Slide from 'material-ui/transitions/Slide';
import firebase from 'firebase';
import JoinFeesie from './joinFeesie';

firebase.initializeApp({
  apiKey: "AIzaSyC-IGuGETMrMCxn2gAS0uQCVuzKSA0Frp0",
  authDomain: "feesie-148819.firebaseapp.com",
  databaseURL: "https://feesie-148819.firebaseio.com",
  projectId: "feesie-148819",
  storageBucket: "feesie-148819.appspot.com",
  messagingSenderId: "1070806220125"
});
let database = firebase.database()

function Transition(props) {
  return <Slide direction="up" {...props}/>;
}

class Start extends Component {
  constructor(props) {
    super(props);
    this.joinFeesie = this.joinFeesie.bind(this);
    this.setFeesieId = this.setFeesieId.bind(this);
    this.closeSpotifyLoginDialog = this.closeSpotifyLoginDialog.bind(this);
    this.showSpotifyLoginDialog = this.showSpotifyLoginDialog.bind(this);
    this.checkIfFeesieExists = this.checkIfFeesieExists.bind(this);

    let code = null;

    this.state = {
      feesieIdInput: "000000",
      spotifyToken: code,
      showSpotifyDialog: false,
      feesieExists: false
    };
  }
  checkIfFeesieExists() {
    let feesies = database.ref('feesies');
    let feesieId = this.state.feesieIdInput;
    let _this = this;
    feesies.once('value', function(snapshot) {
      snapshot.forEach(snap => {
        if (snap.key === feesieId) {
          _this.setState({feesieExists: true})
          _this.setState({spotifyToken: snap.val().spotify_data.spotifyToken});
          _this.joinHandleFeesie();
        }
      });
    });
  }

  joinFeesie() {
    this.checkIfFeesieExists();
  }

  joinHandleFeesie() {
    if (this.state.feesieExists && this.state.spotifyToken) {
      sessionStorage.setItem("spotifyToken", this.state.spotifyToken);
      sessionStorage.setItem("feesieId", this.state.feesieIdInput);
      window.location = "/party";
    }
  }

  setFeesieId(evt) {
    this.setState({feesieIdInput: evt.target.value});
  }

  closeSpotifyLoginDialog() {
    this.setState({showSpotifyDialog: false});
  }

  showSpotifyLoginDialog() {
    this.setState({showSpotifyDialog: true});
  }

  render() {
    return <div className="App">
      <div className="main-content">
       <JoinFeesie joinFeesie={this.joinFeesie}/>

        {
          (!this.state.spotifyToken) && <Dialog open={this.state.showSpotifyDialog} transition={Transition} keepMounted="keepMounted"
              aria-labelledby="alert-dialog-slide-title" aria-describedby="alert-dialog-slide-description">
              <DialogTitle id="alert-dialog-slide-title">
                {"Inloggen met Spotify"}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-slide-description">
                  Spotify heeft het recent verplict gemaakt om in te loggen met je Spotify account om deze app te gebruiken. We werken aan een oplossing
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={this.showSpotifyLogin} color="primary">
                  Inloggen
                </Button>
              </DialogActions>
            </Dialog>
        }
      </div>
    </div>
  }
}
export default Start;



// WEBPACK FOOTER //
// ./src/Start.js